module.exports = "/_next/static/images/be678e672698b343effbe997af6f640c-worldcup-xs-2x.jpg";